import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material';
import { HttpClientModule } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FileUploadModule } from 'ng2-file-upload';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { AppLoaderService } from './app-loader.service';
import { ImageCompressService, ResizeOptions } from '@artiomsu/ng2-image-compress';
import { MaterialCssVarsModule } from "angular-material-css-vars";


export function serviceLoader(appLoader: AppLoaderService){
  return ()=> appLoader.init();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    MaterialCssVarsModule.forRoot({
      isAutoContrast: false,
      primary: "#18334c",
    }),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatProgressSpinnerModule,
    HttpClientModule,
    MatInputModule,
    FileUploadModule,
    ImageCropperModule,
  ],
  exports: [
  ],
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    JwtHelperService,
    { provide: 
      APP_INITIALIZER, useFactory: serviceLoader, deps:[AppLoaderService], multi: true
    },
    ImageCompressService,ResizeOptions
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }

